import { isUndefined } from 'lodash';
import { Button } from 'components/Button';
import { useTranslation } from 'react-i18next';

type ActionButtonsProps = {
  value?: string;
  disabled?: boolean;
  loading?: boolean;
  onSubmit: () => void;
  onSkip: () => Promise<void>;
};

const ActionButtons = ({ value, disabled, loading, onSubmit, onSkip }: ActionButtonsProps) => {
  const { t } = useTranslation();

  return (
    <div className="flex-1 md:space-x-32 sm:space-x-32">
      <Button
        data-testid="pre-book-submit-button"
        size="lg"
        disabled={disabled || isUndefined(value) || value.length === 0}
        loading={loading}
        className="flex-1 sm-d:w-full"
        onClick={() => {
          onSubmit();
        }}
      >
        {t('signup.direct.steps.prebook.actions.submit')}
      </Button>

      <Button
        data-testid="pre-book-skip-button"
        variant="navItem"
        size="lg"
        disabled={loading}
        className="flex-1 sm-d:w-full"
        onClick={async () => {
          await onSkip();
        }}
      >
        {t('signup.direct.steps.prebook.actions.skip')}
      </Button>
    </div>
  );
};

export default ActionButtons;
